import * as React from 'react';
import { withDataFetchNivo } from '../hoc/withDataFetchNivo';

const ResponsiveStream = React.lazy(() =>
  import('@nivo/stream').then(module => ({
    default: module.ResponsiveStream,
  }))
);

// import { ResponsiveStream } from '@nivo/stream'

const StreamWidget: React.FC<any> = ({ data }) => {
  const {
    keys,
    margin,
    axisTop,
    axisBottom,
    axisLeft,
    offsetType,
    colors,
    fillOpacity,
    borderColor,
    defs,
    fill,
    dotSize,
    dotColor,
    dotBorderWidth,
    dotBorderColor,
    animate,
    motionStiffness,
    motionDamping,
    legends,
  } = data.view;

  return (
    <React.Suspense fallback="loading...">
      <ResponsiveStream
        data={data.data}
        keys={keys}
        margin={margin}
        axisTop={axisTop}
        axisRight={null}
        axisBottom={axisBottom}
        axisLeft={axisLeft}
        offsetType={offsetType}
        colors={colors}
        fillOpacity={fillOpacity}
        borderColor={borderColor}
        defs={defs}
        fill={fill}
        dotSize={dotSize}
        dotColor={dotColor}
        dotBorderWidth={dotBorderWidth}
        dotBorderColor={dotBorderColor}
        animate={animate}
        motionStiffness={motionStiffness}
        motionDamping={motionDamping}
        legends={legends}
      />
    </React.Suspense>
  );
};

export default withDataFetchNivo(StreamWidget);
